function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useRefCallback } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { DateContainer } from '../../units/date';
import { DateRangePanel } from '../date-range-panel';
import DynamicDateHeader, { ActiveTab } from './DynamicDateHeader';
import { DynamicDateView } from './DynamicDateView';
import { dateRangeConverters, dynamicDateRangeToFixedDateRange, isDynamicDateRange } from './util';
export * from './types';
export function DynamicDateRangePanel(props) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$converters = props.converters,
      converters = _props$converters === void 0 ? dateRangeConverters : _props$converters,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      dynamicCategories = props.dynamicCategories,
      dynamicPresets = props.dynamicPresets,
      _props$fixedPresets = props.fixedPresets,
      fixedPresets = _props$fixedPresets === void 0 ? [] : _props$fixedPresets,
      _props$format = props.format,
      format = _props$format === void 0 ? 'YYYY-MM-DD' : _props$format,
      _props$onlyShowStart = props.onlyShowStart,
      onlyShowStart = _props$onlyShowStart === void 0 ? false : _props$onlyShowStart,
      _props$startDay = props.startDay,
      startDay = _props$startDay === void 0 ? 0 : _props$startDay,
      value = props.value,
      _props$onChange = props.onChange,
      onChange = _props$onChange === void 0 ? function () {
    return null;
  } : _props$onChange,
      _props$onValueChange = props.onValueChange,
      onValueChange = _props$onValueChange === void 0 ? function () {
    return null;
  } : _props$onValueChange,
      others = _objectWithoutProperties(props, ["className", "converters", "disabled", "dynamicCategories", "dynamicPresets", "fixedPresets", "format", "onlyShowStart", "startDay", "value", "onChange", "onValueChange"]);

  var onChangeCallback = useRefCallback(onChange);
  var onValueChangeCallback = useRefCallback(onValueChange);
  var handleChange = useCallback(function (val) {
    if (isDynamicDateRange(val)) {
      onValueChangeCallback(val);
      onChangeCallback(val);
    } else {
      var newVal = {
        type: 'fixed',
        value: val
      };
      onValueChangeCallback(newVal);
      onChangeCallback(newVal);
    }
  }, []);

  var _useState = useState(ActiveTab.DYNAMIC),
      _useState2 = _slicedToArray(_useState, 2),
      tab = _useState2[0],
      setTab = _useState2[1];

  var dateLocal = useLocale('date');
  var fixedDate = isDynamicDateRange(value) ? dynamicDateRangeToFixedDateRange({
    dynamicDate: value,
    format: format,
    dateLocal: dateLocal,
    weekStartDay: startDay,
    converters: converters
  }) : value;
  var fixedStart = fixedDate === null || fixedDate === void 0 ? void 0 : fixedDate.value[0];
  var fixedEnd = fixedDate === null || fixedDate === void 0 ? void 0 : fixedDate.value[onlyShowStart ? 0 : 1];
  var fixedValue = [fixedStart, fixedEnd].filter(Boolean);
  var cls = classnames(usePrefixCls('dynamic-date', {
    panel: true,
    range: !onlyShowStart
  }), className);
  return React.createElement(DateContainer, {
    className: cls,
    onResetPanel: function onResetPanel() {
      return null;
    },
    header: React.createElement(DynamicDateHeader, {
      active: tab,
      onTabChange: setTab
    })
  }, tab === ActiveTab.DYNAMIC ? React.createElement(DynamicDateView, {
    categories: dynamicCategories,
    className: className,
    disabled: disabled,
    fixedValue: fixedDate === null || fixedDate === void 0 ? void 0 : fixedDate.value,
    onlyShowStart: onlyShowStart,
    presets: dynamicPresets,
    value: isDynamicDateRange(value) ? value : undefined,
    wider: !!(fixedPresets === null || fixedPresets === void 0 ? void 0 : fixedPresets.length),
    onChange: handleChange
  }) : React.createElement(DateRangePanel, Object.assign({
    disabled: disabled,
    format: format,
    presets: fixedPresets,
    startDay: startDay,
    value: fixedValue,
    onChange: handleChange,
    offset: onlyShowStart ? 1 : undefined
  }, others)));
}